module.exports = __webpack_public_path__ + "static/media/landingpage.def04f07.jpg";